import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Swal from "sweetalert2";

const ModalComponent = ({ isOpen, onRequestClose, data, ProductItemDetailID, ProductName, onSubmit }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [isSubmit, setIsSubmit] = useState(false);
    const [isOTPSubmit, setIsOTPSubmit] = useState(false);
    const [isQuotationModal, setIsQuotationModal] = useState(false);
    const [isQuotationRequestClose, setIsQuotationRequestClose] = useState(false);
    const [isQuotationSubmit, setQuotationSubmit] = useState(false);
    const [userdata, setUserData] = useState([]);

    const [isMobileNo, setIsMobile] = useState(true);
    const [isOTP, setIsOTP] = useState(false);
    const [isWrongOTP, setIsWrongOTP] = useState(false);
    const [validMail, setValidMail] = useState(false);

    // console.log("dhfsjfhsjfhskfjd", ProductName);

    useEffect(() => {
        setIsMobile(true);
        setIsOTP(false)
        setFormData({
            mobileNo: {
                textValue: "",
                required: true,
                valid: false,
            },
            email: {
                textValue: "",
                required: true,
                valid: false,
            },
            otp: {
                textValue: "",
                required: false,
                valid: false,
            }
        });
    }, []);

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            opacity: 1,
            padding: '0',
            position: 'absolute',
            border: '1px solid rgb(204, 204, 204)',
            background: 'rgb(255, 255, 255)',
            overflow: 'auto',
            borderRadius: '4px',
            outline: 'none'
        },
    };

    const [formData, setFormData] = useState({
        mobileNo: {
            textValue: "",
            required: true,
            valid: false,
        },
        email: {
            textValue: "",
            required: true,
            valid: false,
        },
        otp: {
            textValue: "",
            required: false,
            valid: false,
        }
    });

    const [quotationformData, setQuotationFormData] = useState({
        username: {
            textValue: "",
            required: true,
            valid: false,
        },
        businessName: {
            textValue: "",
            required: false,
            valid: false,
        },
        websiteURL: {
            textValue: "",
            required: false,
            valid: false,
        },
        qtyInPiece: {
            textValue: "",
            required: true,
            valid: false,
        },
        machineType: {
            textValue: "",
            required: false,
            valid: false,
        },
        productOtherTypeDetailID: {
            textValue: "",
            required: false,
            valid: false,
        },
        requirementDetail: {
            textValue: "",
            required: true,
            valid: false,
        }
    });

    const handleChange = (e) => {
        let lastInputString = e.target.value[e.target.value.length - 1];
        console.log(lastInputString);

        if (e.target.name == "mobileNo") {
            setFormData({
                ...formData,
                [e.target.name]: {
                    ...formData[e.target.name],
                    textValue: e.target.value,
                    valid: e.target.value.length === 10 ? true : false,
                },
            });
        } else if (e.target.name == "otp") {
            setFormData({
                ...formData,
                [e.target.name]: {
                    ...formData[e.target.name],
                    textValue: e.target.value,
                    valid: e.target.value.length === 4 ? true : false,
                },
            });
        }

        if (e.target.name === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(e.target.value)) {
                setValidMail(true);
            } else {
                setValidMail(false);
            }
        }

        setFormData({
            ...formData,
            [e.target.name]: {
                ...formData[e.target.name],
                textValue: e.target.value
            },
        });
    };

    const handleQuotationChange = (e) => {
        setQuotationFormData({
            ...quotationformData,
            [e.target.name]: {
                ...quotationformData[e.target.name],
                textValue: e.target.value,
            },
        });
    };

    const updateData = (newData) => {
        setUserData(newData);
        // console.log("userdata------------>", userdata);
    };

    const handleCloseSubmit = () => {
        setIsQuotationModal(false)

        setFormData({
            mobileNo: {
                textValue: "",
                required: true,
                valid: false,
            },
            email: {
                textValue: "",
                required: true,
                valid: false,
            }
        });
        setQuotationFormData({
            username: {
                textValue: "",
                required: true,
                valid: false,
            },
            businessName: {
                textValue: "",
                required: false,
                valid: false,
            },
            websiteURL: {
                textValue: "",
                required: false,
                valid: false,
            },
            qtyInPiece: {
                textValue: "",
                required: true,
                valid: false,
            },
            machineType: {
                textValue: "",
                required: false,
                valid: false,
            },
            productOtherTypeDetailID: {
                textValue: "",
                required: false,
                valid: false,
            },
            requirementDetail: {
                textValue: "",
                required: true,
                valid: false,
            }
        });
    }

    const handleSubmit = async (e) => {
        // debugger;
        e.preventDefault();
        setIsSubmit(true);
        let validForm = true;
        for (let key in formData) {
            if (formData[key].required) {
                if (!formData[key].textValue) {
                    validForm = false;
                }

                if (!validForm) {
                    return;
                }
            }
        }
        if (formData.mobileNo.textValue.length !== 10) {
            setFormData((prev) => {
                let updatedValue = {
                    ...prev,
                    mobileNo: {
                        ...prev.mobileNo,
                        valid: false,
                    },
                };
                return updatedValue;
            });
            validForm = false;

            if (validForm == false) {
                return;
            }
        }
        if (!validMail) {
            return;
        }
        console.log(formData);
        try {
            const res = await fetch(
                `${baseUrl}User/SetUser`,
                {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        MobileNo: formData.mobileNo.textValue,
                        EmailID: formData.email.textValue
                    }),
                }
            );
            const result = await res.json();
            // console.log(result, "result");
            if (result.status === 1) {
                // updateData(result.data)

                //Update OTP
                var generatedOTP = Math.floor(1000 + Math.random() * 9000);

                const updateres = await fetch(
                    `${baseUrl}User/UpdateOTP`,
                    {
                        method: "post",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            UserID: result.data[0].UserID,
                            EmailID: result.data[0].EmailID,
                            OTP: generatedOTP
                        }),
                    }
                );
                const resultData = await updateres.json();
                updateData(resultData.data)

                isOpen = false
                setFormData({
                    mobileNo: {
                        textValue: "",
                        required: false,
                        valid: false,
                    },
                    email: {
                        textValue: "",
                        required: false,
                        valid: false,
                    },
                    otp: {
                        textValue: "",
                        required: true,
                        valid: false,
                    }
                });

                setIsSubmit(false);
                setIsMobile(false)
                setIsOTP(true)

                // Send OTP SMS

                // let sendSMS = "Your One Time Password (OTP) " + generatedOTP + " to complete your login process - SM Techno Consultants";

                // var smslink = `http://msg.spinningdisk.in/api/mt/SendSMS?APIKey=XSL1xzm6jE6Jvmtz2I9eDw&senderid=SMTCPL&channel=Trans&DCS=0&flashsms=0&number=` + resultData.data[0].MobileNo + `&text=` + encodeURIComponent(sendSMS) + `&route=2&Peid=1701159323681623317&DLTTemplateId=1707169753765431809`
                // await axios.get(smslink);

            }
        } catch (err) {
            console.log(err, "err");
        }
    };

    const handleOTPSubmit = async (e) => {
        // debugger;
        e.preventDefault();
        setIsOTPSubmit(true);
        let validForm = true;
        for (let key in formData) {
            if (formData[key].required) {
                if (!formData[key].textValue) {
                    validForm = false;
                }

                if (!validForm) {
                    return;
                }
            }
        }
        if (formData.otp.textValue.length !== 4) {
            setFormData((prev) => {
                let updatedValue = {
                    ...prev,
                    otp: {
                        ...prev.otp,
                        valid: false,
                    },
                };
                return updatedValue;
            });
            validForm = false;

            if (validForm == false) {
                return;
            }
        }

        if (formData.otp.textValue === userdata[0].OTP) {
            setIsWrongOTP(false)
            console.log(formData);
            try {
                isOpen = false
                setFormData({
                    mobileNo: {
                        textValue: "",
                        required: true,
                        valid: false,
                    },
                    email: {
                        textValue: "",
                        required: true,
                        valid: false,
                    },
                    otp: {
                        textValue: "",
                        required: false,
                        valid: false,
                    }
                });
                setIsOTP(false);
                onSubmit(false)
                setIsQuotationModal(true)

                setQuotationFormData({
                    ...quotationformData,
                    username: {
                        textValue: "",
                        required: userdata[0].Name == null ? true : false,
                        valid: false,
                    }
                });
            } catch (err) {
                console.log(err, "err");
            }
        } else {
            setIsWrongOTP(true)
        }
    };

    const handleQuotationSubmit = async (e) => {
        debugger;
        // console.log("quotationformData----------->", quotationformData);
        e.preventDefault();
        setQuotationSubmit(true);
        let validForm = true;
        for (let key in quotationformData) {
            if (quotationformData[key].required) {
                if (!quotationformData[key].textValue) {
                    validForm = false;
                }
                if (!validForm) {
                    return;
                }
            }
        }

        // console.log("shajahdahsdkadajkda", userdata);
        try {
            const res = await fetch(
                `${baseUrl}User/SetUser`,
                {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        UserID: userdata ? userdata[0].UserID : null,
                        MobileNo: userdata ? userdata[0].MobileNo : null,
                        Name: userdata ? userdata[0].Name != null ? userdata[0].Name : quotationformData.username.textValue : quotationformData.username.textValue,
                        EmailID: userdata ? userdata[0].EmailID : null,
                        CompanyName: userdata ? userdata[0].CompanyName != null ? userdata[0].CompanyName : quotationformData.businessName.textValue : quotationformData.businessName.textValue,
                        WebsiteURL: userdata ? userdata[0].WebsiteURL != null ? userdata[0].WebsiteURL : quotationformData.websiteURL.textValue : quotationformData.websiteURL.textValue,
                        OTP: userdata ? userdata[0].OTP != null ? userdata[0].OTP : null : null
                    }),
                }
            );
            const result = await res.json();
            console.log(result, "result");
            const resProductDetail = await fetch(
                `${baseUrl}QuotationEnquiry/SetQuotationEnquiry`,
                {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        UserID: userdata ? userdata[0].UserID : null,
                        ProductItemDetailID: ProductItemDetailID,
                        QuantityInPiece: quotationformData.qtyInPiece.textValue,
                        MachineType: quotationformData.machineType.textValue,
                        ProductOtherTypeDetailID: quotationformData.productOtherTypeDetailID.textValue,
                        RequirementDetail: quotationformData.requirementDetail.textValue,
                        ProductItemName: ProductName,
                        MobileNo: userdata ? userdata[0].MobileNo : null,
                        Name: userdata ? userdata[0].Name != null ? userdata[0].Name : quotationformData.username.textValue : quotationformData.username.textValue,
                    }),
                }
            );
            const resultProductDetailData = await resProductDetail.json();

            if (resultProductDetailData.status === 1) {
                // console.log("result.data------------>", result.data);

                Swal.fire({
                    title: "Thank You",
                    text: "We thank you for sending your valuable enquiry to us. We shall get back to you shortly.",
                    icon: "success",
                    timer: 5000,
                });

                setIsQuotationModal(false)
                setQuotationFormData({
                    username: {
                        textValue: "",
                        required: true,
                        valid: false,
                    },
                    businessName: {
                        textValue: "",
                        required: false,
                        valid: false,
                    },
                    websiteURL: {
                        textValue: "",
                        required: false,
                        valid: false,
                    },
                    qtyInPiece: {
                        textValue: "",
                        required: true,
                        valid: false,
                    },
                    machineType: {
                        textValue: "",
                        required: false,
                        valid: false,
                    },
                    productOtherTypeDetailID: {
                        textValue: "",
                        required: false,
                        valid: false,
                    },
                    requirementDetail: {
                        textValue: "",
                        required: true,
                        valid: false,
                    }
                });
                setQuotationSubmit(false);
                setIsQuotationRequestClose(false);
                setValidMail(false);
                setIsMobile(true);
                setIsOTP(false)
            }
        } catch (err) {
            console.log(err, "err");
        }
    }

    const handleCloseModel = () => {
        setIsMobile(true);
        setIsOTP(false)
        setFormData({
            mobileNo: {
                textValue: "",
                required: true,
                valid: false,
            },
            email: {
                textValue: "",
                required: true,
                valid: false,
            },
            otp: {
                textValue: "",
                required: false,
                valid: false,
            }
        });

        setQuotationFormData({
            username: {
                textValue: "",
                required: true,
                valid: false,
            },
            businessName: {
                textValue: "",
                required: false,
                valid: false,
            },
            websiteURL: {
                textValue: "",
                required: false,
                valid: false,
            },
            qtyInPiece: {
                textValue: "",
                required: true,
                valid: false,
            },
            machineType: {
                textValue: "",
                required: false,
                valid: false,
            },
            productOtherTypeDetailID: {
                textValue: "",
                required: false,
                valid: false,
            },
            requirementDetail: {
                textValue: "",
                required: true,
                valid: false,
            }
        });

        onRequestClose();
    }

    return (
        <>
            <Modal
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                style={customStyles}
                // style={{ opacity: 1 }}
                contentLabel="Example Modal"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='modal-dialog'
                shouldCloseOnOverlayClick={false}
            >
                <div>
                    <h2 className='modal-header font20 m-0 pb-10'>User Information</h2>
                    {isMobileNo &&
                        <>
                            <div className='modal-body'>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="mobileNo" className="col-form-label">Mobile No:<span style={{ color: "red" }}>*</span></label>
                                        <input type="text" autoComplete='off' className="form-control allowNumberKey" id="mobileNo" name='mobileNo' required value={formData.mobileNo.textValue} maxLength={10} onChange={handleChange} />
                                        {isSubmit && !formData.mobileNo.textValue && (
                                            <span style={{ color: "red" }}>
                                                Please Enter Mobile No
                                            </span>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email" className="col-form-label">Email ID:<span style={{ color: "red" }}>*</span></label>
                                        <input type="text" autoComplete='off' className="form-control" id="email" name='email' value={formData.email.textValue} maxLength={255} onChange={handleChange} />
                                        {isSubmit && (!validMail || !formData.email.textValue) && (
                                            <span style={{ color: "red" }}>
                                                Please Enter Email
                                            </span>
                                        )}
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer'>
                                <button type="submit" onClick={handleSubmit} className='btn btn-primary'>Submit</button>
                                <button onClick={handleCloseModel} className='btn btn-danger'>Close</button>
                            </div>
                        </>
                    }

                    {isOTP &&
                        <>
                            <div className='modal-body'>
                                <form onSubmit={handleOTPSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="otp" className="col-form-label">OTP: (OTP Send on your Email)<span style={{ color: "red" }}>*</span></label>
                                        <input type="text" autoComplete='off' className="form-control allowNumberKey" id="otp" name='otp' required value={formData.otp.textValue} maxLength={4} onChange={handleChange} />
                                        {isOTPSubmit && !formData.otp.textValue && (
                                            <span style={{ color: "red" }}>
                                                Please Enter OTP
                                            </span>
                                        )}

                                        {isOTPSubmit && isWrongOTP && (
                                            <span style={{ color: "red" }}>
                                                Please Enter Valid OTP
                                            </span>
                                        )}
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer'>
                                <button type="submit" onClick={handleOTPSubmit} className='btn btn-primary'>Submit</button>
                                <button onClick={handleCloseModel} className='btn btn-danger'>Close</button>
                            </div>
                        </>
                    }
                </div>
            </Modal>

            <Modal
                isOpen={isQuotationModal}
                onRequestClose={isQuotationRequestClose}
                style={customStyles}
                // style={{ opacity: 1 }}
                contentLabel="Example Modal"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='modal-dialog'
                shouldCloseOnOverlayClick={false}
            >
                <div>
                    <h2 className='modal-header font20 m-0 pb-10'>Product Quotation</h2>
                    <div className='modal-body'>
                        <form onSubmit={handleQuotationSubmit}>
                            <div className='row'>
                                {userdata.length &&
                                    <>
                                        {userdata[0].Name != '' && userdata[0].Name != null ?
                                            <p className='col-md-6'>Name: <label className="col-form-label">{userdata[0].Name}</label></p> : null}
                                        <p className='col-md-6'>Mobile No: <label className="col-form-label">{userdata[0].MobileNo}</label></p>
                                    </>
                                }
                            </div>
                            <div className='row'>

                                {userdata.length &&
                                    <>
                                        {userdata[0].Name == null ?
                                            <div className="form-group col-md-6">
                                                <label htmlFor="username" className="col-form-label">Name:<span style={{ color: "red" }}>*</span></label>
                                                <input type="text" autoComplete='off' className="form-control" id="username" name='username' required value={quotationformData.username.textValue} maxLength={200} onChange={handleQuotationChange} />
                                                {isQuotationSubmit && !quotationformData.username.textValue && (
                                                    <span style={{ color: "red" }}>
                                                        Please Enter Name
                                                    </span>
                                                )}
                                            </div> : null
                                        }
                                        {userdata[0].WebsiteURL == null ?
                                            <div className="form-group col-md-6">
                                                <label htmlFor="websiteURL" className="col-form-label">Website URL:</label>
                                                <input type="text" autoComplete='off' className="form-control" id="websiteURL" name='websiteURL' value={quotationformData.websiteURL.textValue} maxLength={100} onChange={handleQuotationChange} />
                                            </div> : null
                                        }
                                        {/* {userdata[0].EmailID == null ?
                                            <div className="form-group col-md-6">
                                                <label htmlFor="email" className="col-form-label">Email ID:</label>
                                                <input type="text" autoComplete='off' className="form-control" id="email" name='email' value={quotationformData.email.textValue} maxLength={255} onChange={handleQuotationChange} />
                                                {isSubmit && (!validMail || !formData.EmailID.textValue) && (
                                                    <span style={{ color: "red" }}>
                                                        Please Enter Valid Email
                                                    </span>
                                                )}
                                            </div> : null
                                        } */}
                                        {userdata[0].CompanyName == null ?
                                            <div className="form-group col-md-12">
                                                <label htmlFor="businessName" className="col-form-label">Company / Business Name:</label>
                                                <input type="text" autoComplete='off' className="form-control" id="businessName" name='businessName' value={quotationformData.businessName.textValue} maxLength={500} onChange={handleQuotationChange} />
                                            </div> : null
                                        }

                                    </>
                                }
                                <div className="form-group col-md-4">
                                    <label htmlFor="qtyInPiece" className="col-form-label">Qty In Piece:<span style={{ color: "red" }}>*</span></label>
                                    <input type="text" autoComplete='off' className="form-control allowNumberKey" id="qtyInPiece" required name='qtyInPiece' value={quotationformData?.qtyInPiece?.textValue} maxLength={10} onChange={handleQuotationChange} />
                                    {isQuotationSubmit && !quotationformData.qtyInPiece.textValue && (
                                        <span style={{ color: "red" }}>
                                            Please Enter Qty
                                        </span>
                                    )}
                                </div>
                                <div className="form-group col-md-8">
                                    <label htmlFor="machineType" className="col-form-label">Machin Type:</label>
                                    <div className='form-control' style={{ border: '1px solid #555' }}>
                                        <label>
                                            <input
                                                type="radio"
                                                value="Automatic"
                                                name="machineType"
                                                checked={quotationformData?.machineType?.textValue === 'Automatic'}
                                                onChange={handleQuotationChange}
                                            /><span>&nbsp;</span>
                                            Automatic
                                        </label>

                                        <label>
                                            <span>&nbsp;</span>
                                            <input
                                                type="radio"
                                                value="Semi Automatic"
                                                name="machineType"
                                                checked={quotationformData.machineType.textValue === 'Semi Automatic'}
                                                onChange={handleQuotationChange}
                                            /><span>&nbsp;</span>
                                            Semi Automatic
                                        </label>

                                        <label>
                                            <span>&nbsp;</span>
                                            <input
                                                type="radio"
                                                value="Manual"
                                                name="machineType"
                                                checked={quotationformData.machineType.textValue === 'Manual'}
                                                onChange={handleQuotationChange}
                                            /><span>&nbsp;</span>
                                            Manual
                                        </label>
                                    </div>
                                </div>
                                {data &&
                                    <div className="form-group col-md-12">
                                        <label htmlFor="productOtherTypeDetailID" className="col-form-label">Type:</label>
                                        <select className='form-control' style={{ border: '1px solid #555' }} name='productOtherTypeDetailID' onChange={handleQuotationChange}>
                                            <option value=''>--Select Type--</option>
                                            {data.map((otherType, index) => (
                                                <option value={otherType.ProductOtherTypeDetailID}>{otherType.Type}</option>
                                            ))}
                                        </select>
                                    </div>
                                }
                                <div className="form-group col-md-12">
                                    <label htmlFor="requirementDetail" className="col-form-label">Requirement Details:<span style={{ color: "red" }}>*</span></label>
                                    {/* <input type="text" autoComplete='off' className="form-control" id="requirementDetail" name='requirementDetail' value={quotationformData.requirementDetail.textValue} onChange={handleQuotationChange} /> */}

                                    <textarea
                                        name="requirementDetail"
                                        value={quotationformData.requirementDetail.textValue}
                                        onChange={handleQuotationChange}
                                        placeholder="Requirement Detail"
                                        className="form-control"
                                        required
                                        style={{ border: '1px solid #555' }}
                                    />
                                    {isQuotationSubmit && !quotationformData.requirementDetail.textValue && (
                                        <span style={{ color: "red" }}>
                                            Please Enter Your Requirement Detail
                                        </span>
                                    )}

                                </div>
                            </div>
                        </form>
                    </div>
                    <div className='modal-footer'>
                        <button type="submit" onClick={handleQuotationSubmit} className='btn btn-primary'>Submit</button>
                        <button onClick={handleCloseSubmit} className='btn btn-danger'>Close</button>
                    </div>
                </div >
            </Modal >
        </>
    );
};

export default ModalComponent;
